"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizationPriorities = exports.ERROR_CODE = exports.TASK_FIFO = exports.ValidLimitations = exports.WayPointType = exports.ActivityType = exports.SquashType = exports.FleetSize = exports.DMEngine = exports.OptimizationSolver = exports.UnassignedAfterOptimization = exports.UnassignedBeforeOptimization = exports.UnassignedJobReasonForServer = exports.UnassignedJobReason = exports.Actions = exports.DEFAULT_OPTIMIZATION_PARAMETERS = void 0;
exports.DEFAULT_OPTIMIZATION_PARAMETERS = {
    TASK_PRIORITY: 2,
    TASK_DURATION_IN_MINUTES: 1,
    TASK_CAPACITY: 1,
    USER_TYPE_CAPACITY: 1,
    USER_TYPE_COST: 1,
    USER_TYPE_ID: 0,
    MIN_OPTIMIZATION_PRIORITY: 10
};
var Actions;
(function (Actions) {
    Actions["ScheduledRouteOptimization"] = "scheduled_route_optimization";
    Actions["BatchScheduledRouteOptimization"] = "batch_scheduled_route_optimization";
    Actions["RouteOptimizationRequest"] = "route_optimization_request";
    Actions["RouteOptimizationRpcRequest"] = "route_optimization_request_rpc";
    Actions["RouteOptimizationCacheRefresh"] = "route_optimization_cache_refresh";
    Actions["RouteOptimizationDone"] = "route_optimization_done";
    Actions["CalculateDistanceMatrix"] = "calculate_distance_matrix";
    Actions["CalculateRoutesResponse"] = "help_build_distance_matrix_response";
    Actions["CalculateETA"] = "calculate_eta";
    Actions["AcceptQuote"] = "accept_quote";
    Actions["SplitToClusters"] = "split_to_clusters";
})(Actions || (exports.Actions = Actions = {}));
var UnassignedJobReason;
(function (UnassignedJobReason) {
    UnassignedJobReason["reason_not_found"] = "reason not found";
    UnassignedJobReason["out_of_max_distance"] = "cannot be assigned due to max distance constraint of vehicle";
    UnassignedJobReason["no_driver_in_tasks_time_window"] = "no driver in appropriate time window";
    UnassignedJobReason["exceed_all_drivers_allowed_maximal_load"] = "Exceed all drivers maximal load";
    UnassignedJobReason["exceed_all_drivers_containers"] = "Exceed all drivers containers";
    UnassignedJobReason["no_driver_with_required_skills"] = "no_driver_with_required_skills";
    UnassignedJobReason["excluded_from_all_drivers"] = "no driver that can serve the job";
    UnassignedJobReason["driver_that_task_assign_to_not_found_in_optimization"] = "driver that task assigned to not found in optimization";
    UnassignedJobReason["active_task_not_assigned_to_driver"] = "active task not assigned to driver";
    UnassignedJobReason["illegal_coordinate"] = "illegal coordinate";
    UnassignedJobReason["task_assigned_to_driver_that_rejected_the_task"] = "task assigned to driver that rejected the task";
    UnassignedJobReason["invalid_capacity_dimensions_for_task"] = "invalid capacity dimensions for task";
    UnassignedJobReason["negative_capacity_requirements"] = "The capacity value must not be negative.";
    UnassignedJobReason["negative_max_time_in_vehicle"] = "The maximum time in vehicle must be positive.";
    UnassignedJobReason["negative_service_time"] = "The service time of must be positive";
    UnassignedJobReason["negative_loading_time"] = "The loading time of must be positive";
    UnassignedJobReason["max_time_in_vehicle_not_supported_for_job_type"] = "The maximum time in vehicle is not yet supported for Pickups and Services.";
    UnassignedJobReason["invalid_priority"] = "The priority value is not valid. Only 1 (very high) to 10 (very low) are allowed.";
    UnassignedJobReason["load_constrains"] = "does not fit into any vehicle due to capacity";
    UnassignedJobReason["time_constraints"] = "cannot be visited within time window";
    UnassignedJobReason["time_or_customer_availability_constraints"] = "Order cannot be fulfilled at this time due to time window or your availability limitations";
    UnassignedJobReason["skills_constraint"] = "cannot serve required skill";
    UnassignedJobReason["max_time_in_vehicle_constraint"] = "cannot be assigned due to max time on vehicle constraint of vehicle";
    UnassignedJobReason["failed_to_pack"] = "failed to pack";
    UnassignedJobReason["route_constraint"] = "failed due to route constraint";
    UnassignedJobReason["driving_times_limitations"] = "failed due driving time limitations";
    UnassignedJobReason["failed_to_find_driver_for_cluster"] = "failed to find driver for cluster";
    UnassignedJobReason["tasks_unmatched_conditions"] = "Order removed from optimization due to unmatched conditions";
})(UnassignedJobReason || (exports.UnassignedJobReason = UnassignedJobReason = {}));
exports.UnassignedJobReasonForServer = {
    'reason not found': 'reason_not_found',
    'cannot be assigned due to max distance constraint of vehicle': 'OUT_OF_MAX_DISTANCE',
    'no driver in appropriate time window': 'NO_DRIVER_IN_TASKS_TIME_WINDOW',
    'Exceed all drivers maximal load': 'EXCEED_ALL_DRIVERS_ALLOWED_MAXIMAL_LOAD',
    'Exceed all drivers containers': 'EXCEED_ALL_DRIVERS_CONTAINERS',
    no_driver_with_required_skills: 'NO_DRIVER_WITH_REQUIRED_SKILLS',
    'no driver that can serve the job': 'EXCLUDED_FROM_ALL_DRIVERS',
    'driver that task assigned to not found in optimization': 'DRIVER_THAT_TASK_ASSIGN_TO_NOT_FOUND_IN_OPTIMIZATION',
    'active task not assigned to driver': 'ACTIVE_TASK_NOT_ASSIGNED_TO_DRIVER',
    'illegal coordinate': 'ILLEGAL_COORDINATE',
    'task assigned to driver that rejected the task': 'TASK_ASSIGNED_TO_DRIVER_THAT_REJECTED_THE_TASK',
    'invalid capacity dimensions for task': 'INVALID_CAPACITY_DIMENSIONS_FOR_TASK',
    'The capacity value must not be negative.': 'NEGATIVE_CAPACITY_REQUIREMENTS',
    'The maximum time in vehicle must be positive.': 'NEGATIVE_MAX_TIME_IN_VEHICLE',
    'The service time of must be positive': 'NEGATIVE_SERVICE_TIME',
    'The loading time of must be positive': 'NEGATIVE_LOADING_TIME',
    'The maximum time in vehicle is not yet supported for Pickups and Services.': 'MAX_TIME_IN_VEHICLE_NOT_SUPPORTED_FOR_JOB_TYPE',
    'The priority value is not valid. Only 1 (very high) to 10 (very low) are allowed.': 'INVALID_PRIORITY',
    'does not fit into any vehicle due to capacity': 'LOAD_CONSTRAINS',
    'cannot be visited within time window': 'TIME_CONSTRAINTS',
    'Order cannot be fulfilled at this time due to time window or your availability limitations': 'TIME_OR_CUSTOMER_AVAILABILITY_CONSTRAINTS',
    'cannot serve required skill': 'SKILLS_CONSTRAINT',
    'cannot be assigned due to max time on vehicle constraint of vehicle': 'MAX_TIME_IN_VEHICLE_CONSTRAINT',
    'failed to pack': 'FAILED_TO_PACK',
    'failed due to route constraint': 'ROUTE_CONSTRAINT',
    'failed due driving time limitations': 'DRIVING_TIMES_LIMITATIONS',
    'failed to find driver for cluster': 'FAILED_TO_FIND_DRIVER_FOR_CLUSTER',
    'failed due to routing area': 'FAILED_TO_INSERT_DUE_TO_ROUTING_AREA'
};
exports.UnassignedBeforeOptimization = [
    UnassignedJobReason.out_of_max_distance,
    UnassignedJobReason.no_driver_in_tasks_time_window,
    UnassignedJobReason.no_driver_with_required_skills,
    UnassignedJobReason.exceed_all_drivers_allowed_maximal_load,
    UnassignedJobReason.exceed_all_drivers_containers,
    UnassignedJobReason.excluded_from_all_drivers,
    UnassignedJobReason.driver_that_task_assign_to_not_found_in_optimization,
    UnassignedJobReason.active_task_not_assigned_to_driver,
    UnassignedJobReason.illegal_coordinate,
    UnassignedJobReason.task_assigned_to_driver_that_rejected_the_task,
    UnassignedJobReason.invalid_capacity_dimensions_for_task,
    UnassignedJobReason.negative_capacity_requirements,
    UnassignedJobReason.negative_max_time_in_vehicle,
    UnassignedJobReason.negative_service_time,
    UnassignedJobReason.negative_loading_time,
    UnassignedJobReason.max_time_in_vehicle_not_supported_for_job_type,
    UnassignedJobReason.invalid_priority,
    UnassignedJobReason.tasks_unmatched_conditions
];
exports.UnassignedAfterOptimization = [
    UnassignedJobReason.load_constrains,
    UnassignedJobReason.time_constraints,
    UnassignedJobReason.time_or_customer_availability_constraints,
    UnassignedJobReason.skills_constraint,
    UnassignedJobReason.failed_to_find_driver_for_cluster,
    UnassignedJobReason.failed_to_pack,
    UnassignedJobReason.route_constraint,
    UnassignedJobReason.max_time_in_vehicle_constraint,
    UnassignedJobReason.driving_times_limitations
];
var OptimizationSolver;
(function (OptimizationSolver) {
    OptimizationSolver["G2S"] = "g2s";
    OptimizationSolver["Vroom"] = "vroom";
    OptimizationSolver["Jsprit"] = "jsprit";
    OptimizationSolver["GoogleCloudFleetRouting"] = "google_cfr";
})(OptimizationSolver || (exports.OptimizationSolver = OptimizationSolver = {}));
var DMEngine;
(function (DMEngine) {
    DMEngine["OSRM"] = "osrm";
    DMEngine["GRAPHHOPPER"] = "graphhopper";
    DMEngine["NEXTBILLION"] = "nextbillion";
    DMEngine["HERE"] = "here";
    DMEngine["VALHALLA"] = "valhalla";
    DMEngine["ORS"] = "ors";
    DMEngine["UNKNOWN"] = "unknown";
})(DMEngine || (exports.DMEngine = DMEngine = {}));
var FleetSize;
(function (FleetSize) {
    FleetSize["Finite"] = "FINITE";
    FleetSize["Infinite"] = "INFINITE_WITH_BREAKS";
})(FleetSize || (exports.FleetSize = FleetSize = {}));
var SquashType;
(function (SquashType) {
    SquashType["Pickup"] = "pu";
    SquashType["Dropoff"] = "do";
})(SquashType || (exports.SquashType = SquashType = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["foot"] = "foot";
    ActivityType["vehicle"] = "vehicle";
})(ActivityType || (exports.ActivityType = ActivityType = {}));
var WayPointType;
(function (WayPointType) {
    WayPointType[WayPointType["pickup"] = 0] = "pickup";
    WayPointType[WayPointType["delivery"] = 1] = "delivery";
})(WayPointType || (exports.WayPointType = WayPointType = {}));
exports.ValidLimitations = ['mustBeOnTop', 'mustBeOnBottom', 'disable2DRotation'];
var TASK_FIFO;
(function (TASK_FIFO) {
    TASK_FIFO[TASK_FIFO["none"] = 0] = "none";
    TASK_FIFO[TASK_FIFO["by_pickup"] = 1] = "by_pickup";
    TASK_FIFO[TASK_FIFO["by_dropoff"] = 2] = "by_dropoff";
})(TASK_FIFO || (exports.TASK_FIFO = TASK_FIFO = {}));
var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["NO_DRIVER_TYPE_PASSED"] = 1] = "NO_DRIVER_TYPE_PASSED";
    ERROR_CODE[ERROR_CODE["NO_ROUTE_START_IN_DRIVER_SHIFT"] = 2] = "NO_ROUTE_START_IN_DRIVER_SHIFT";
    ERROR_CODE[ERROR_CODE["NO_DRIVER_PASSED"] = 3] = "NO_DRIVER_PASSED";
    ERROR_CODE[ERROR_CODE["NO_DRIVER_TYPES_PASSED"] = 4] = "NO_DRIVER_TYPES_PASSED";
    ERROR_CODE[ERROR_CODE["NO_TASKS_PASSED"] = 5] = "NO_TASKS_PASSED";
    ERROR_CODE[ERROR_CODE["NO_ROUTES_FOR_CALCULATE_ETA"] = 6] = "NO_ROUTES_FOR_CALCULATE_ETA";
    ERROR_CODE[ERROR_CODE["NO_DROP_OFF_FOR_PICK_UP_TASK"] = 7] = "NO_DROP_OFF_FOR_PICK_UP_TASK";
    ERROR_CODE[ERROR_CODE["NO_PICK_UP_AND_DROP_OFF_FOR_TASK"] = 8] = "NO_PICK_UP_AND_DROP_OFF_FOR_TASK";
    ERROR_CODE[ERROR_CODE["INVALID_ROUTE_START_LOCATION"] = 9] = "INVALID_ROUTE_START_LOCATION";
    ERROR_CODE[ERROR_CODE["INVALID_TIME_WINDOW_ON_BREAK"] = 10] = "INVALID_TIME_WINDOW_ON_BREAK";
    ERROR_CODE[ERROR_CODE["INVALID_BREAK_DURATION_LESS_THEN_ZERO"] = 11] = "INVALID_BREAK_DURATION_LESS_THEN_ZERO";
    ERROR_CODE[ERROR_CODE["INVALID_DRIVERS_LOCATION"] = 12] = "INVALID_DRIVERS_LOCATION";
    ERROR_CODE[ERROR_CODE["INVALID_TASK_PRIORITY"] = 13] = "INVALID_TASK_PRIORITY";
    ERROR_CODE[ERROR_CODE["INVALID_TIME_WINDOW_ON_WAY_POINT"] = 14] = "INVALID_TIME_WINDOW_ON_WAY_POINT";
    ERROR_CODE[ERROR_CODE["INVALID_COORDINATE"] = 15] = "INVALID_COORDINATE";
    ERROR_CODE[ERROR_CODE["INVALID_RUN_ID"] = 16] = "INVALID_RUN_ID";
    ERROR_CODE[ERROR_CODE["ABNORMAL_REQUEST"] = 17] = "ABNORMAL_REQUEST";
    ERROR_CODE[ERROR_CODE["INVALID_VEHICLE_DIMENSIONS"] = 18] = "INVALID_VEHICLE_DIMENSIONS";
    ERROR_CODE[ERROR_CODE["INVALID_TASK_DIMENSIONS"] = 19] = "INVALID_TASK_DIMENSIONS";
    ERROR_CODE[ERROR_CODE["INVALID_DRIVER_TIME_WINDOW"] = 20] = "INVALID_DRIVER_TIME_WINDOW";
    ERROR_CODE[ERROR_CODE["INVALID_DRIVERS_QUANTITY"] = 21] = "INVALID_DRIVERS_QUANTITY";
    ERROR_CODE[ERROR_CODE["INVALID_ETOS"] = 22] = "INVALID_ETOS";
    ERROR_CODE[ERROR_CODE["TIMEOUT"] = 23] = "TIMEOUT";
    ERROR_CODE[ERROR_CODE["NOT_ENOUGH_TIME_TO_RUN_OPTIMIZATION"] = 24] = "NOT_ENOUGH_TIME_TO_RUN_OPTIMIZATION";
    ERROR_CODE[ERROR_CODE["OPTIMIZATION_SOLVER_INTERNAL_ERROR"] = 25] = "OPTIMIZATION_SOLVER_INTERNAL_ERROR";
    ERROR_CODE[ERROR_CODE["REQUEST_EXCEED_QUOTA"] = 26] = "REQUEST_EXCEED_QUOTA";
    ERROR_CODE[ERROR_CODE["TOO_MANY_FAILED_OPTIMIZATIONS_FOR_TIME_WINDOW"] = 27] = "TOO_MANY_FAILED_OPTIMIZATIONS_FOR_TIME_WINDOW";
})(ERROR_CODE || (exports.ERROR_CODE = ERROR_CODE = {}));
var OptimizationPriorities;
(function (OptimizationPriorities) {
    OptimizationPriorities["CLUSTERED"] = "CLUSTERED";
    OptimizationPriorities["MIN_DRIVERS"] = "MIN_DRIVERS";
    OptimizationPriorities["MIN_UNASSIGNED"] = "MIN_UNASSIGNED";
    OptimizationPriorities["FAIRNESS"] = "FAIRNESS";
    OptimizationPriorities["MIN_TIME"] = "MIN_TIME";
})(OptimizationPriorities || (exports.OptimizationPriorities = OptimizationPriorities = {}));
//# sourceMappingURL=route_optimizer_types.js.map